import type { ParseKeys } from 'i18next';
import { ReactNode } from 'react';
enum TaskType {
  Bug = 'bug',
  Story = 'story',
  Task = 'task',
  Subtask = 'sub-task',
  Spike = 'spike',
  Epic = 'epic',
}

/**
 * Maps task type values to their i18n dictionary keys for types that have custom translations.
 * Used by label/display functions to resolve translated names instead of hardcoded strings.
 */
const taskTypeI18nKeys: Record<string, ParseKeys<'translation'>> = {
  [TaskType.Epic]: 'common.parent_task',
};

type TaskTypeValue = TaskType | string;

type Epic = {
  id: string;
  name: string;
  url: string;
  title: string;
};

type Initiative = {
  id: string;
  name: string;
};

type TaskTransition = {
  status: string;
  changed_by: string;
  changed_at: string;
};

type TaskRecord = {
  id: string;
  name: string;
  title: string;
  url: string;
  created_date: string;
  points: number | null;
  type: TaskType | null;
  raw_type: string | null;
  raw_type_label?: string | null;
  epic: Epic | null;
  initiatives: Initiative[];
  transitions?: TaskTransition[];
};

type SortedColumn = 'title' | 'name' | 'epics' | 'initiatives' | 'points' | 'type' | 'created' | 'transitions';

enum Grouping {
  Initiative = 'initiatives',
  Epic = 'epics',
  Points = 'points',
  Type = 'type',
}

type CollapseState = {
  [key: string]: boolean;
};

interface TasksTableProps {
  tasks: TaskRecord[];
  dateRange?: ReactNode | string;
}

enum ToggleCollapseValue {
  COLLAPSE_ALL = 'collapseAll',
  EXPAND_ALL = 'expandAll',
}

export { Grouping, taskTypeI18nKeys, TaskType, ToggleCollapseValue };
export type { CollapseState, SortedColumn, TaskRecord, TasksTableProps, TaskTransition, TaskTypeValue };
